import React, { Component, Fragment } from "react";
import {Modal, ModalBody, Button, ModalHeader } from "reactstrap";
import ProyectoIngresoFrom from "./ProyectoDetailForm"

class ProyectoIngresoModal extends Component {
    state = {
        modal: false
      };

    toggle = () => {
    this.setState(previous => ({
        modal: !previous.modal
    }));
    };  

    render() {
        const create = this.props.create;
        const proyectoCode = this.props.proyectoCodeSelected;
        const proyectoName = this.props.proyectoNameSelected;
        const proyectoMoneda = this.props.proyectoMoneda;

        var title = "Editando Instructor del Proyecto";
        var button = <Button onClick={this.toggle}>
        Editar
        </Button>;

        if (create) {
            title = "Aggregando Instructor del Proyecto ";

            button = (
            <Button
                color="primary"
                className="float-end"
                onClick={this.toggle}
                style={{ minWidth: "200px" }}
            >
                Agregar Instructor
            </Button>
            );
        }

    return (
      <Fragment>
        {button}
        <Modal isOpen={this.state.modal} toggle={this.toggle} unmountOnClose>
        <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <ModalBody>
            <ProyectoIngresoFrom
              resetState={this.props.resetState}
              toggle={this.toggle}
              proyectoCode= {proyectoCode}
              proyectoName = {proyectoName}
              proyectoMoneda = {proyectoMoneda}
              selectedProyecto={this.props.selectedProyecto}
              instructor={this.props.instructor}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default ProyectoIngresoModal;